import Lenis from "lenis";
import { createContext, useContext, useEffect, useState } from "react";

const LenisContext = createContext(null);

export const useLenis = () => useContext(LenisContext);

/**
 * Site-wide Lenis smooth scroll (lerp 0.1).
 * Disabled entirely when the visitor prefers reduced motion.
 */
export default function SmoothScrollProvider({ children }) {
  const [lenis, setLenis] = useState(null);

  useEffect(() => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced) return undefined;

    const instance = new Lenis({ lerp: 0.1, smoothWheel: true });
    setLenis(instance);

    let rafId;
    const frame = (time) => {
      instance.raf(time);
      rafId = requestAnimationFrame(frame);
    };
    rafId = requestAnimationFrame(frame);

    return () => {
      cancelAnimationFrame(rafId);
      instance.destroy();
      setLenis(null);
    };
  }, []);

  return <LenisContext.Provider value={lenis}>{children}</LenisContext.Provider>;
}
